import { render, staticRenderFns } from "./WeeklySchedule.vue?vue&type=template&id=4fc8fb40&scoped=true"
import script from "./WeeklySchedule.vue?vue&type=script&lang=js"
export * from "./WeeklySchedule.vue?vue&type=script&lang=js"
import style0 from "./WeeklySchedule.vue?vue&type=style&index=0&id=4fc8fb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8fb40",
  null
  
)

export default component.exports